<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['options','height','width','data'],
  methods: {
    newData: function() {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            data: this.soumis,
            fill: false,
            borderColor: "rgba(123,111,255, 0.6)", // <-- supposed to be light blue
            label: "Soumis"
          },
          {
            data: this.debute,
            fill: false,
            borderColor: "rgba(255,152,111,0.6)",
            label: "Débutés"
          },
        ]},
        {
          title: {
            display: true,
            fontSize: 20,
            text: 'Changements hebdomadaires'
          },
          // responsive: false,
          // Can't just just `stacked: true` like the docs say
          scales: {
            // xAxes: [{ stacked: true }],
            yAxes: [{
              position: 'left',
              gridLines: {
                color: "rgba(123,111,255, 0.3)",
              },
              scaleLabel: {
                display: true,
                labelString: 'Changements'
              },
              ticks: {min: 0, suggestedMax: 20 },
              // stacked: true,
            }],
          },
          animation: {
            duration: 750,
          },
        }
      )
    }
  },
  computed: {
    labels: function() {
      let result = [];
      for (const [,value] of Object.entries(this.data)) {
        result.push(value.semaine);
      }
      return result;
    },
    // datasets
    debute: function() {
      let result = [];
      for (const [,value] of Object.entries(this.data)) {
        result.push(value.debute);
      }
      return result;
    },
    soumis: function() {
      let result = [];
      for (const [,value] of Object.entries(this.data)) {
        result.push(value.soumis);
      }
      return result;
    }
  },
  watch: {
    data: function() {
      this.newData();
    }
  },
  mounted() {
    this.newData();
  }
}
</script>
